import { Trans } from "@lingui/react/macro";
import React from "react";
import CruiseHeaderDisclaimer from "src/page-components/cruise/CruiseInfoSummary/CruiseHeaderDisclaimer/CruiseHeaderDisclaimer";
import PlaceholderValuesFormatter from "components/PlaceholderValueFormatter/PlaceholderValueFormatter";
import { PricesFrom } from "./PricesFrom/PricesFrom";
import type { TokenValueEncoded } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import { isPresent } from "src/utils/checks";
import { CruisePriceAndOffersV2Response } from "src/ssc-api/prices/useCruisePrice";

type Props = {
  className?: string;
  prices: CruisePriceAndOffersV2Response | undefined;
  comboShipBoardCredit: TokenValueEncoded | undefined;
};

const PriceRecap: React.FC<Props> = ({
  className,
  prices,
  comboShipBoardCredit
}) => {
  return (
    <div className={className}>
      <PricesFrom priceFrom={prices?.priceFrom}>
        {isPresent(comboShipBoardCredit) && (
          <CruiseHeaderDisclaimer>
            <Trans id="combo-ship-board-credit-disclaimer">
              Enjoy{" "}
              <PlaceholderValuesFormatter
                placeholder="combo_ship_board_credit"
                value={comboShipBoardCredit}
              />{" "}
              ship board credit
            </Trans>
          </CruiseHeaderDisclaimer>
        )}
      </PricesFrom>
    </div>
  );
};

export default PriceRecap;
